import { Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage.service';
import { Router } from '@angular/router';
import { WhereUsedItem } from '@cpak/interfaces';
import { DialogOutletService } from '../dialog-outlet';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WhereUsedService extends DialogOutletService {
  private countryId$ = new BehaviorSubject<string | null>(null);
  constructor(private localStorage: LocalStorageService, router: Router) {
    super(router, 'where-used');
  }

  public override onCloseModal(): void {
    super.onCloseModal();
    this.countryId$.next(null);
    this.localStorage.remove('where-used-product');
  }

  public override onOpenModal(id: string, countryId?: string): void {
    super.onOpenModal(id);
    this.countryId$.next(countryId || null);
  }

  public getCountryId(): string | null {
    return this.countryId$.getValue();
  }

  public storeProduct(product: WhereUsedItem): void {
    this.localStorage.setItem('where-used-product', product);
  }

  public getStoredProduct(): WhereUsedItem {
    return this.localStorage.getItem('where-used-product');
  }
}
